var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gather',{attrs:{"height":_vm.height,"width":_vm.width,"type":"water"}})
}
var staticRenderFns = []

export { render, staticRenderFns }